import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ComingSoonToast from './ComingSoonToast';
import './Download.css';

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M16.4 12.5c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.8-3.5.8s-1.8-.8-3-.8c-1.5 0-2.9.9-3.7 2.3C3.2 12.3 4.3 17 6 19.6c.8 1.3 1.8 2.7 3.1 2.7s1.7-.8 3.2-.8 1.9.8 3.2.8 2.2-1.3 3-2.6c1-1.5 1.4-3 1.4-3.1-.1 0-2.5-1-2.5-3.8zM14.1 5.1c.7-.8 1.1-2 1-3.1-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1.1 3 1.1.1 2.2-.6 3-1.4z" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M5 3l14 9-14 9V3z" />
  </svg>
);

const STAGGER = { hidden: {}, visible: { transition: { staggerChildren: 0.1 } } };
const FADE_UP = { hidden: { opacity: 0, y: 8 }, visible: { opacity: 1, y: 0 } };
const T = { duration: 0.52, ease: [0.22, 1, 0.36, 1] };

const Download = () => {
  const [toast, setToast] = useState(false);

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => setToast(false), 3000);
    return () => clearTimeout(id);
  }, [toast]);

  const showToast = () => setToast(true);

  return (
    <>
      <motion.section
        className="cta-section"
        id="download"
        variants={STAGGER}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.25 }}
      >
        <motion.div className="cta-left" variants={FADE_UP} transition={T}>
          <div className="eyebrow">Get pawprints</div>
          <h2>
            Free forever.<br />
            Yours from <em>day one</em>.
          </h2>
        </motion.div>
        <motion.div className="cta-right" variants={FADE_UP} transition={T}>
          <p>No subscription required.</p>
          <div className="store-buttons">
            <button className="store-btn" onClick={showToast}>
              <AppleIcon />
              <span>
                <span className="store-eyebrow">Download on the</span>
                <span className="store-name">App Store</span>
              </span>
            </button>
            <button className="store-btn" onClick={showToast}>
              <PlayIcon />
              <span>
                <span className="store-eyebrow">Get it on</span>
                <span className="store-name">Google Play</span>
              </span>
            </button>
          </div>
        </motion.div>
      </motion.section>
      <ComingSoonToast message="Coming soon!" isVisible={toast} />
    </>
  );
};

export default Download;
